import React from "react"
import DataGrid from "devextreme-react/data-grid"
import { onRefresh, onStart, onSaving, onSaved, onToolbarPreparing, MyImage } from "../../../public/module/extra"

class LeaveApproval extends React.PureComponent {
    constructor(props) {
        super(props)
        this.state = onStart({ ...props })
    }
    componentDidUpdate = () => {
        if (!this.state.prepared) onRefresh({ object: this })
    }
    componentDidMount = () => {
        if (!this.state.prepared) onRefresh({ object: this })
    }
    render() {
        return this.state.prepared ? (
            <DataGrid
                height="100%"
                dataSource={this.state.dataSource}
                onSaved={(e) => onSaved(e, { object: this })}
                onSaving={(e) => onSaving(e, { object: this })}
                onInitialized={(e) => this.setState({ grid: e.component })}
                onToolbarPreparing={(e) => onToolbarPreparing(e, { object: this })}
                keyExpr="id"
                columnAutoWidth={true}
                wordWrapEnabled={true}
                width="100%"
                onCellClick={(e, x) => {
                    if (e.column.dataField === "employee_id")
                        if (e.data.image !== null && e.data.image !== undefined)
                            this.state.fn.modal({
                                children: (
                                    <div className="w-100 h-100 d-flex align-items-center justify-content-center">
                                        <MyImage style={{ maxHeight: "90%" }} url={e.data.image} />
                                    </div>
                                )
                            })
                }}
                columns={[
                    {
                        dataField: "employee_id",
                        sortOrder: "asc",
                        caption: this.state.columnTitle.employee_id,
                        allowEditing: false,
                        lookup: {
                            dataSource: this.state.employee,
                            displayExpr: "name",
                            valueExpr: "id"
                        }
                    },
                    {
                        dataField: "leave_type_id",
                        caption: this.state.columnTitle.leave_type_id,
                        allowEditing: false,
                        lookup: {
                            dataSource: this.state.leaveType,
                            displayExpr: "name",
                            valueExpr: "id"
                        }
                    },
                    {
                        dataField: "description",
                        caption: this.state.columnTitle.description,
                        allowEditing: false
                    },
                    {
                        dataField: "start_date",
                        caption: this.state.columnTitle.start_date,
                        allowEditing: false,
                        dataType: "date",
                        format: "dd MMM yyyy"
                    },
                    {
                        dataField: "end_date",
                        caption: this.state.columnTitle.end_date,
                        allowEditing: false,
                        dataType: "date",
                        format: "dd MMM yyyy"
                    },
                    {
                        dataField: "start_time",
                        caption: this.state.columnTitle.start_time,
                        allowEditing: false
                    },
                    {
                        dataField: "end_time",
                        caption: this.state.columnTitle.end_time,
                        allowEditing: false
                    },
                    {
                        dataField: "full_day",
                        caption: this.state.columnTitle.full_day,
                        allowEditing: false,
                        dataType: "boolean"
                    },
                    {
                        dataField: "approve",
                        caption: this.state.columnTitle.approve,
                        dataType: "boolean",
                        setCellValue: (a, b, c, $) => {
                            $ = { new: a, value: b, old: c }
                            $.new.approve = $.value
                            // eslint-disable-next-line
                            eval(
                                "if ($.value){" +
                                    "$.new.reject = false;" +
                                    "} else {" +
                                    "$.new.is_leave_reduction = false;" +
                                    "$.new.is_salary_reduction = false;" +
                                    "}"
                            )
                        }
                    },
                    {
                        dataField: "is_salary_reduction",
                        caption: this.state.columnTitle.is_salary_reduction,
                        dataType: "boolean",
                        setCellValue: (a, b, c, $) => {
                            $ = { new: a, value: b, old: c }
                            $.new.is_salary_reduction = $.value
                            if ($.value) {
                                $.new.reject = false
                                $.new.approve = true
                                $.new.is_leave_reduction = false
                            }
                        }
                    },
                    {
                        dataField: "is_leave_reduction",
                        caption: this.state.columnTitle.is_leave_reduction,
                        dataType: "boolean",
                        setCellValue: (a, b, c, $) => {
                            $ = { new: a, value: b, old: c }
                            $.new.is_leave_reduction = $.value
                            if ($.value) {
                                $.new.reject = false
                                $.new.approve = true
                                $.new.is_salary_reduction = false
                            }
                        }
                    },
                    {
                        dataField: "reject",
                        caption: this.state.columnTitle.reject,
                        dataType: "boolean",
                        setCellValue: (a, b, c, $) => {
                            $ = { new: a, value: b, old: c }
                            $.new.reject = $.value
                            if ($.value) {
                                $.new.is_salary_reduction = false
                                $.new.is_leave_reduction = false
                                $.new.approve = false
                            }
                        }
                    }
                ]}
                filterRow={true}
                searchPanel={true}
                editing={{ mode: "batch", allowUpdating: true, useIcons: true }}
            />
        ) : (
            "Please wait..."
        )
    }
}
export default LeaveApproval
